import Vue from 'vue';
import { API_BASE_URL } from '@/config';
export default {
  get_sub_layer_wdm_list (query) {
    return Vue.http.post(API_BASE_URL + 'v1/layer/get/sub/wdm/list?' + query);
  }
};
